import React from 'react';
import {PaginationData} from '../types';

type UsePaginationDataOptions = {
    itemLabels?: string[];
    defaultLabel?: string;
    getXOfYLabel?: (index: number, length: number) => string;
    formatTabId: (index: number) => string;
    formatPanelId: (index: number) => string;
};

export const usePaginationData = (
    itemCount: number,
    options: UsePaginationDataOptions
): PaginationData[] => {
    const {
        defaultLabel = '',
        formatPanelId,
        formatTabId,
        getXOfYLabel,
        itemLabels = []
    } = options;

    return React.useMemo<PaginationData[]>(() => {
        return Array.from({length: itemCount}, (_, index) => {
            const baseLabel = itemLabels[index] || defaultLabel;
            const positionLabel = getXOfYLabel?.(index + 1, itemCount) || '';

            const label = (
                <span key={index}>
                    {baseLabel}
                    {positionLabel && `, ${positionLabel}`}
                </span>
            );

            return {
                label,
                id: formatTabId(index),
                panelId: formatPanelId(index)
            };
        });
    }, [
        itemCount,
        itemLabels,
        defaultLabel,
        getXOfYLabel,
        formatTabId,
        formatPanelId
    ]);
};
